<template>
  <div class="Home">
    <header>
      <div class="h-title"> 
        <img src="../assets/images/logo.png" width="145">
        <img src="../assets/images/title.png" width="150" height="83">
      </div>
      <img class='h-bgimg' src="../assets/images/h-bgimg.png" width="150" height="160">
    </header>
    <nav class="appli-btn" @click="applicate">
      <img class='appli-bgimg' src="../assets/images/appli-btn.png" width="100%" height="76">
      <div class="btn-text">
        <img src="../assets/images/appli-icon.png" width="32" height="32">
        <p>新申请</p>
      </div>
    </nav>
    <dialog-bar v-model="sendVal" type="confirm" title="线上翻译申办须知" :confirmText="'知道了'">
      <div class="Serverclaim">
<p>欢迎您使用广州公证处线上翻译服务！</p>
<p>您可足不出户，随时随地申办中、外文互译的翻译服务。</p>
<p>本线上翻译服务仅针对文件提供翻译，如您需对文件进行翻译并公证，请通过广州公证处公众号-网上公证-开始申办进行在线申请。</p>
<p>广州公证处线上翻译仅证明译文与原文内容相符，不对原文的真实性进行审核，但您必须对文件的来源负责。</p>
<p>您一旦提交申请，视为您委托广州公证处文件翻译服务中心对您提交的文件提供翻译服务，或同意广州公证处文件翻译服务中心委托南京学府翻译公司为您提供翻译服务。</p>
<p>您提交翻译的文件必须合法合规。以下类型的文件不予翻译：涉及国家秘密、危害国家安全、违背公序良俗及其他不合法不合规的文件。</p>
<p>申请流程：申请—公证处审核—定价—缴费—翻译—邮寄翻译文件。</p>
<p>您可以亲自前往广州公证处文件翻译服务中心领取翻译文件，但我们建议您通过邮寄方式领取，以节约您的时间。</p>
<p>如文件中涉及专有名词、固定译名、人名等，请您在备注栏准确填写其中文译名或外文译名。</p>
<p>由于您上传的文件将与翻译文本合并装订，建议上传文件的扫描件，也可以使用手机的扫描功能或使用“扫描全能王”小程序 进行拍照。</p>
<p>如审核过程中发现上传的文件不符合要求，广州公证处工作人员会及时与您联系，请您保持通信畅通予以配合并重新上传。</p>
<p>请您如实填写个人信息、开票信息及邮寄地址，以便开具电子发票及邮寄翻译文件。</p>
<div class="bgimg">
<img src="../assets/images/smqnewm.png" width="200" height="200" />
</div>
</div>
    </dialog-bar>
    <mt-popup v-model="clickAppli" position="bottom" popup-transition="popup-fade" class="pop-gz">
          <div class="title">提示告知</div>
          <div style="padding:0 15px;">
          <label style="text-align:left;display:flex;align-items:center;"><input type="checkbox" name="" id="" @click="ischecked">我已阅读并同意<span @click.prevent="showxz">《申办须知》</span>相关内容</label>
          </div>
          <div class="gz-btn">
            <mt-button type='default' style="width:45%;" @click.native="closegz">取消</mt-button>
            <mt-button :disabled="!isgzchecked" style="width:45%;background-color:#1E70E0;color:white;"  @click.native="know">确定</mt-button>
          </div>
      </mt-popup>
    <div class="content">
    <aside class="c-left o-btn" @click="toNopay">
      <img src="../assets/images/nopay-img.png" width="176" height="274">
      <div class="o-text" style="bottom:30px;">
        <p>待支付订单</p>
        <p>Order pending</p>
      </div>
    </aside>
    <div class="content-right">
    <section class="o-btn" @click="toHistory">
      <img src="../assets/images/history-img.png" width="176" height="132">
      <div class="o-text">
        <img src="../assets/images/h-icon.png" width="50" height="50">
        <p>我的申请记录</p>
        <p>My application record</p>
      </div>
    </section>
    <article class="o-btn" @click="toClaim">
      <img src="../assets/images/claim-img.png" width="176" height="132">
      <div class="o-text">
        <img src="../assets/images/c-icon.png" width="55" height="46">
        <p>翻译服务说明</p>
        <p>Translation Service Instructions</p>
      </div>
    </article>
    </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui';
import { Popup } from 'mint-ui';
import dialogBar from '@/components/common/dialog.vue'
export default {
  components:{
        'dialog-bar': dialogBar,
    },
  name: 'HelloWorld',
  data () {
    return {
      clickAppli:false,
      gzchecked:"",
      isgzchecked:false,
      sendVal: false,
    }
  },
  created(){
  },
  methods:{
    showxz(index){
            this.sendVal = true;
        },
    applicate(){
      this.clickAppli=true;
    },
    
    toNopay(){
      this.$router.push("/Nopay.html");
    },
    toClaim(){
      this.$router.push("/Serverclaim.html");
    },
    toHistory(){
      this.$router.push("/History.html");
    },
    closegz(){
      this.clickAppli=false;
    },
    ischecked(){
      this.isgzchecked=event.target.checked;
    },
    know(){
      if(this.isgzchecked){
        this.clickAppli=false
        this.$router.push("/Application.html");
      }else{
        Toast('请勾选告知说明');
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Serverclaim{
    text-align: left;
    color: #585858;
    font-size: 13px;
    padding: 15px 0;
    line-height: 1.5;
}
.Serverclaim p{text-indent: 30px;}
.bgimg{
    text-align:center;
}
header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}
.h-title{
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  line-height: 1.5;
}
.appli-btn{
  height: 76px;
  color: white;
  position: relative;
}
.btn-text{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-indent:5px;
  letter-spacing: 1px;
}
.content{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
.content-right{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
}
.c-left{
  margin-right: 5px;
}
.o-btn{
  position: relative;
}
.o-text{
  position: absolute;
  bottom: 15px;
  left: 15px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  line-height: 1.5;
  letter-spacing: 1px;
}
.o-text p:last-child{
font-size: 12px;
}
.o-btn p{
  padding: 0;
  margin: 0;
}
.pop-gz{
  width: 100%;
  padding: 30px;
}
.pop-gz .title{
  font-size: 18px;
  color: black;
}
.pop-gz label{
  font-size: 14px;
  color: #919191;
  line-height: 5;
}
.pop-gz span{
  color: #2E68E0;
}
.pop-gz input[type="checkbox"]{
  width: 20px;
  height: 20px;
  margin: 0 10px;
  color: #1E70E0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue